import { render, staticRenderFns } from "./EstablishProductNew.vue?vue&type=template&id=bcbca50a&scoped=true"
import script from "./EstablishProductNew.vue?vue&type=script&lang=js"
export * from "./EstablishProductNew.vue?vue&type=script&lang=js"
import style0 from "./EstablishProductNew.vue?vue&type=style&index=0&id=bcbca50a&prod&lang=scss&scoped=true"
import style1 from "./EstablishProductNew.vue?vue&type=style&index=1&id=bcbca50a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbca50a",
  null
  
)

export default component.exports